// FICHIER : frontend/src/components/NavLogo.jsx
// Logo navbar : icône TOS + texte "TOS" côte à côte
export default function NavLogo({ height = 40 }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, height }}>
      <img
        src="/logo-tos.png"
        alt="TOS"
        style={{ height, width: height, borderRadius: 8, objectFit: 'cover' }}
      />
      <span style={{ fontFamily: 'Syne, sans-serif', fontWeight: 900, fontSize: 24, lineHeight: 1, whiteSpace: 'nowrap' }}>
        <span style={{ color: '#1B3A4B' }}>T</span>
        <span style={{ color: '#4CAF50' }}>O</span>
        <span style={{ color: '#F5C518' }}>S</span>
      </span>
    </div>
  );
}
